import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useMemo } from "react";
import LandingPage from "./pages/LandingPage";
import SessionPage from "./pages/SessionPage";
import { useApiKeyContext } from "./contexts/ApiKeyContext";
import ApiKeyPrompt from "./components/ApiKeyPrompt";

const LandingEntry = () => {
  const location = useLocation();
  const fallback = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const session = params.get("session");
    return session ? <Navigate to={`/session/${session}`} replace /> : null;
  }, [location.search]);

  return fallback ?? <LandingPage />;
};

const App = () => {
  const { apiKey, setApiKey, initialized } = useApiKeyContext();

  if (!initialized) {
    return null;
  }

  if (!apiKey) {
    return <ApiKeyPrompt onSubmit={setApiKey} />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingEntry />} />
      <Route path="/session/:sessionId" element={<SessionPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
